import { useEffect, useState } from 'react';
import { previewNoticeBodyPdf } from '../../../services/debt';

const readErrorMessageFromBlob = async (blob) => {
  // 预览接口失败时，后端可能返回 JSON 错误体（而不是 PDF），这里尽量解析出可读提示
  let msg = '预览生成失败';
  try {
    const text = await blob.text();
    try {
      const obj = JSON.parse(text);
      msg = String(obj?.message || obj?.msg || obj?.error || msg);
    } catch (e) {
      msg = String(text || msg);
    }
  } catch (e) {}
  return msg;
};

const usePreviewNoticeBodyPdf = ({ debtId, previewDebtor, contentHtml, pageSettings, previewValues }) => {
  const [previewPdfData, setPreviewPdfData] = useState(null);
  const [previewPdfLoading, setPreviewPdfLoading] = useState(false);
  const [previewPdfError, setPreviewPdfError] = useState('');

  useEffect(() => {
    // 依赖不完整时不触发请求（例如还未选择债务人/模板内容为空）
    if (!debtId || !previewDebtor || !contentHtml) {
      setPreviewPdfData(null);
      setPreviewPdfLoading(false);
      setPreviewPdfError('');
      return undefined;
    }

    let alive = true;
    setPreviewPdfLoading(true);
    setPreviewPdfError('');

    previewNoticeBodyPdf(debtId, {
      contentHtml,
      pageSettings,
      renderValues: previewValues,
    })
      .then(async (res) => {
        if (!alive) return;
        const blob = res?.data instanceof Blob ? res.data : new Blob([res?.data], { type: 'application/pdf' });
        const contentType = String(res?.headers?.['content-type'] || '').toLowerCase();
        // 通过 content-type 兜底判断：避免把 JSON 错误体当成 PDF 渲染
        if (contentType && !contentType.includes('application/pdf')) {
          const msg = await readErrorMessageFromBlob(blob);
          if (!alive) return;
          setPreviewPdfError(msg);
          setPreviewPdfData(null);
          return;
        }
        const ab = await blob.arrayBuffer();
        if (!alive) return;
        setPreviewPdfData(ab);
      })
      .catch(() => {
        if (!alive) return;
        setPreviewPdfError('预览生成失败');
        setPreviewPdfData(null);
      })
      .finally(() => {
        if (alive) setPreviewPdfLoading(false);
      });

    return () => {
      // 组件卸载/依赖变更时标记取消：防止异步回写旧请求结果
      alive = false;
    };
  }, [contentHtml, debtId, pageSettings, previewDebtor, previewValues]);

  return { previewPdfData, previewPdfLoading, previewPdfError };
};

export default usePreviewNoticeBodyPdf;
